<template>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-left">Mis à jour par</th>
        <th class="text-left">Modification</th>
        <th class="text-left">Ancienne valeur</th>
        <th class="text-left">Nouvelle valeur</th>
        <th class="text-left">Date</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in history" :key="item.id">
        <td>{{ item.owner }}</td>
        <td>{{ item.type }}</td>
        <td>{{ item.old }}</td>
        <td>{{ item.new }}</td>
        <td>{{ $moment(item.timestamp).format("DD/MM/YYYY à HH:mm") }}</td>
      </tr>
    </tbody>
  </v-table>
</template>

<script>
import AdminService from "@/services/admin.service";
export default {
  props: ["action", "id"],
  data() {
    return {
      history: [],
      loading: true,
    };
  },
  methods: {},
  async mounted() {
    let data = await AdminService.getConfigHistory(this.action, this.id);

    this.history = data;
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
</style>